import { difference, forEach } from 'lodash/fp';
import type { Root } from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import type { Mount } from './mounts';
import mounts from './mounts';

const rootsWithNodeById: Record<string, { root: Root; node: HTMLElement }> = {};

const getRootWithNode = (id: string) => {
    if (rootsWithNodeById[id]) {
        return rootsWithNodeById[id];
    }

    const node = document.getElementById(id);
    if (!node) {
        return;
    }

    node.setAttribute('ng-non-bindable', 'true');
    const rootWithNode = { root: createRoot(node), node };
    rootsWithNodeById[id] = rootWithNode;
    return rootWithNode;
};

const renderMount = ({ Component, id }: Mount) => {
    const rootWithNode = getRootWithNode(id);
    if (!rootWithNode) {
        return;
    }

    const { root, node } = rootWithNode;

    root.render(<Component mountNode={node} />);
};

const renderAll = (xs: Mount[]) => xs.forEach(renderMount);
const getIds = (xs: Mount[]) => xs.map(x => x.id);

if (module.hot) {
    let currentIds = getIds(mounts);

    module.hot.accept('./mounts', () => {
        const newIds = getIds(mounts);
        const removedIds = difference(currentIds, newIds);
        currentIds = newIds;

        forEach(id => {
            const rootWithNode = rootsWithNodeById[id];
            if (rootWithNode) {
                rootWithNode.root.unmount();
                delete rootsWithNodeById[id];
            }
        }, removedIds);

        renderAll(mounts);
    });
}

renderAll(mounts);
